<form [formGroup]="productDetailsForm" class="product-details-form">
  <div class="form-row">
    <div class="display-field">
      <label class="field-label">Stripe Product ID</label>
      <div class="field-value">{{ productDetailsForm.get('stripeProductId')?.value || 'Not set' }}</div>
    </div>

    <div class="display-field">
      <label class="field-label">Name</label>
      <div class="field-value">{{ productDetailsForm.get('name')?.value || 'Not set' }}</div>
    </div>
  </div>

  <div class="form-row">
    <div class="display-field full-width">
      <label class="field-label">Description</label>
      <div class="field-value description-value">{{ productDetailsForm.get('description')?.value || 'No description' }}</div>
    </div>
  </div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="form-field full-width">
      <mat-label>Metadata (JSON)</mat-label>
      <textarea
        matInput
        formControlName="metadata"
        placeholder='Enter metadata as JSON (e.g., {"key": "value"})'
        rows="4"
        (blur)="formatProductJsonOnBlur('metadata')"
      >
      </textarea>
      <mat-error *ngIf="productDetailsForm.get('metadata')?.hasError('invalidJson')">
        Invalid JSON format
      </mat-error>
    </mat-form-field>
  </div>

  <div class="form-row">
    <div class="display-field">
      <label class="field-label">Price</label>
      <div class="field-value">$ {{ productDetailsForm.get('price')?.value || '0.00' }}</div>
    </div>

    <div class="display-field">
      <label class="field-label">Active Product</label>
      <div class="field-value">
        <span class="status-badge" [class.active]="productDetailsForm.get('active')?.value" [class.inactive]="!productDetailsForm.get('active')?.value">
          {{ productDetailsForm.get('active')?.value ? 'Active' : 'Inactive' }}
        </span>
      </div>
    </div>
  </div>

  <app-billing-cycle-form
    [billingCycles]="billingCycles"
    [billingCycleControl]="billingCycleControl"
    [billingDayControl]="billingDayControl"
  ></app-billing-cycle-form>
  <!-- <div class="form-row">
      <mat-form-field appearance="outline" class="form-field full-width">
        <mat-label>Images (URLs)</mat-label>
        <textarea 
          matInput 
          formControlName="images" 
          placeholder="Enter image URLs, one per line" 
          rows="3">
        </textarea>
      </mat-form-field>
    </div> -->

  <div class="form-actions">
    <button
      mat-raised-button
      color="primary"
      (click)="saveProductDetails()"
      [disabled]="!productDetailsForm.valid"
    >
      Save Product Details
    </button>
    <button mat-button type="button" (click)="resetProductDetailsForm()">Reset</button>
  </div>
</form>
